import React from "react";

// Components
import { CardInfo } from "Common/Components";

import {
  GeneralInfoPage,
  SchedulePage,
  AccuroPage,
  NotificationSettingsPage,
} from "./index";

const ReviewPage = ({
  formik,
  hasTypeId,
  setHasTypeId,
  clinicProp,
  allClients,
  selectedClient,
  appointmentTypes,
  isCustomMessagesChecked,
}) => {
  return (
    <>
      <CardInfo
        title="Review Information"
        tooltipInfo="Review the client's information before finalizing the creation process."
      />
      <GeneralInfoPage formik={formik} allClients={allClients} viewOnly />
      <SchedulePage
        formik={formik}
        selectedClient={selectedClient}
        appointmentTypes={appointmentTypes}
        viewOnly
      />
      <AccuroPage
        formik={formik}
        hasTypeId={hasTypeId}
        setHasTypeId={setHasTypeId}
        clinicProp={clinicProp}
        viewOnly
      />
      <NotificationSettingsPage
        formik={formik}
        allClients={allClients}
        isCustomMessagesChecked={isCustomMessagesChecked}
        viewOnly
      />
    </>
  );
};

export default ReviewPage;
